/* eslint-disable no-dupe-keys */
export default {
  advertisement: {
    name: '广告管理',
    // 属性（一般与对象内容匹配）
    prop: {
      advertising_space: '广告位',
      display_scope: '展示范围',
      advertisements_charge_stations: '展示场站',
      name: '广告名',
      media_type: '媒体类型',
      media: '媒体',
      redirect_type: '跳转类型',
      redirect_page: '跳转页面',
      redirect_url: '跳转页面地址',
      redirect_android_page: '安卓页面配置',
      redirect_iOS_page: 'iOS页面配置',
      redirect_miniprogram_page: '小程序页面配置',
      sort_number: '顺序',
      impressions_count: '展示次数',
      clicks_count: '点击次数',
      status: '状态',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    display_scopes: {
      all_stations: '全部场站',
      specified_stations: '指定场站'
    },
    media_types: {
      image: '图片',
      video: '视频'
    },
    redirect_types: {
      no_redirect: '无跳转',
      app_page: '应用页面',
      page_url: '网页URL'
    },
    statuses: {
      enabled: '已上架',
      disabled: '已下架'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询广告名',
      search_advertising_space: '查询广告位'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      click_record: '点击记录'
    },
    // 详情页
    detail_page: {
      impressions_count: '曝光次数',
      clicks_count: '点击次数',
      click_rate: '点击率'
    },
    // 标签标题
    list_tabs: {
      all: '广告位',
      enabled: '上架的',
      disabled: '下架的'
    },
    // 分组
    group_titles: {
      advertising_space_type: '广告位分类',
      base: '基本信息',
      redirect_page: '跳转页设置',
      display_scope: '展示范围设置'
    },
    // 标题
    titles: {
      media: '媒体',
      base_info: '基本信息',
      display_scope: '展示范围',
      redirect_page: '跳转页面信息',
      statistic: '广告统计'
    }
  }
}
